import React from 'react';
import { ConfigProvider } from 'antd';
import { Route, Routes } from 'react-router-dom';
import Preview from './screen/Preview';
import TestEnv from './screen/TestEnv';
import './App.scss';

const App = () => {
  return (
    <div id="App">
      <ConfigProvider
        theme={{
          token: {
            colorText: '#242450',
            colorPrimary: '#7a4bff',
            borderRadius: 6,
            colorSplit: '#E9E9ED',
          },
          components: {
            Layout: {
              siderBg: '#FFF',
              bodyBg: '#F8F8F8',
              headerBg: '#FFF',
            },
            Form: {
              verticalLabelPadding: '0 0 2px 0',
              labelColor: '#505073',
              labelFontSize: 13,
            },
            Button: {
              borderRadiusLG: 6,
            },
            Slider: {
              handleActiveColor: '#00E0E4',
              handleSize: 18,
              handleSizeHover: 18,
              handleColor: '#FFF',
              controlSize: 12,
            },
          },
        }}
      >
        <Routes>
          <Route path="/" element={<div>Forbidden</div>} />
          <Route path="/web-sdk-preview" element={<Preview />} />
          <Route path="/web-sdk-test-env" element={<TestEnv />} />
        </Routes>
      </ConfigProvider>
    </div>
  );
};

export default App;
